export enum PredictionClass {
  REPAIR = 'repair',
  CHANGE = 'change',
  NO_ACTION = 'no_action'
}
